import React from 'react';

const TrainingIcon = ({ fill = "#5E5E5E", className = "", width = "24", height = "24", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" className={className} {...props}>
        {/* Whiteboard/Presentation board */}
        <rect x="2" y="8" width="20" height="12" rx="1" fill={fill} stroke={fill} strokeWidth="0.5" />
        <rect x="3" y="9" width="18" height="10" fill="white" />

        {/* Whiteboard content - simple presentation lines */}
        <line x1="5" y1="12" x2="15" y2="12" stroke={fill} strokeWidth="0.3" />
        <line x1="5" y1="14" x2="12" y2="14" stroke={fill} strokeWidth="0.3" />
        <line x1="5" y1="16" x2="14" y2="16" stroke={fill} strokeWidth="0.3" />

        {/* Person watching - head */}
        <circle cx="10" cy="5" r="1.5" fill={fill} />

        {/* Person watching - body */}
        <rect x="8.5" y="6.5" width="3" height="4" rx="0.5" fill={fill} />

        {/* Person watching - arms */}
        <rect x="7" y="7.5" width="1" height="2" fill={fill} />
        <rect x="12" y="7.5" width="1" height="2" fill={fill} />

        {/* Person watching - legs */}
        <rect x="9" y="10.5" width="0.8" height="3" fill={fill} />
        <rect x="10.2" y="10.5" width="0.8" height="3" fill={fill} />

        {/* Eyes to show watching */}
        <circle cx="9.2" cy="4.5" r="0.2" fill="white" />
        <circle cx="10.8" cy="4.5" r="0.2" fill="white" />
        <circle cx="9.2" cy="4.5" r="0.1" fill={fill} />
        <circle cx="10.8" cy="4.5" r="0.1" fill={fill} />
    </svg>
);

export default TrainingIcon;